import { PropsWithChildren } from 'react'

import { MdWarning } from 'react-icons/md'
import styled, { css } from 'styled-components'

interface IBackgroundColor {
  backgroundColor: string
}

export const NoContentContainer = styled.div.attrs<
  PropsWithChildren<IBackgroundColor>
>(({ theme }) => ({}))<IBackgroundColor>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 1;

  ${({ backgroundColor }) => css`
    background-color: ${backgroundColor};
  `}
`

export const Message = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
`

export const Icon = styled(MdWarning)`
  color: ${({ theme }) => theme.colors.text};
`
Icon.defaultProps = {
  size: 150,
}
